// Specialized permissions only make sense for particular modules. Filtering
// affects presentation only; saved role values remain intact.
const SPECIAL_ACTION_MENUS = {
  sourcing: ['jobs'],
  assign: ['jobs'],
  approve: ['submissions', 'onboarding', 'assignments', 'timesheet', 'vendors', 'test cases'],
  move_onboard: ['submissions'],
  change_status: ['jobs', 'candidates', 'submissions', 'onboarding', 'assignments'],
  candidate_self: ['candidates'],
  candidate_all: ['candidates'],
  my_jobs: ['jobs'],
  all_jobs: ['jobs'],
  reject: ['submissions', 'onboarding', 'assignments', 'timesheet', 'vendors', 'test cases'],
  viewProposedRate: ['submissions'],
};

export function isPermissionApplicable(menuName, permissionKey) {
  const applicableMenus = SPECIAL_ACTION_MENUS[permissionKey];
  if (!applicableMenus) return true;
  return applicableMenus.includes(String(menuName ?? '').trim().toLowerCase());
}
